module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    class: [_vm.theme, this.isOpen ? '' : 'collapsed-box', _vm.isSolid ? 'box-solid' : '']
  }, [_c('div', {
    staticClass: "box-header",
    class: (_vm.isBorder || _vm.isSolid) ? 'with-border' : ''
  }, [_vm._t("icon-title"), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right",
    staticStyle: {
      "top": "5px"
    }
  }, [(_vm.btnIcon) ? _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": _vm.widgetType,
      "title": _vm.tooltip
    },
    on: {
      "click": function($event) {
        return _vm.btnIconClick()
      }
    }
  }, [_c('i', {
    class: _vm.btnIcon
  })]) : _vm._e(), _vm._v(" "), (_vm.list) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem),
      expression: "selectedItem"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedItem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled"
    }
  }, [_vm._v("Select Dealer")]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.imagesList) ? _c('ul', {
    staticClass: "nav",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('li', {
    staticClass: "dropdown user user-menu"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "height": "450px",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.imagesList), function(img, index) {
    return _c('li', {
      staticClass: "user-header",
      on: {
        "click": function($event) {
          _vm.selectedImageIndex = index
        }
      }
    }, [_c('img', {
      staticClass: "thumbnail-image",
      staticStyle: {
        "padding": "20px",
        "border-radius": "20px"
      },
      attrs: {
        "src": img.Thumbnail,
        "alt": "Printer Image"
      }
    }), _vm._v(" "), _c('hr')])
  }), 0)])]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisible),
      expression: "isVisible"
    }],
    staticClass: "box-body"
  }, [_vm._t("content")], 2), _vm._v(" "), (_vm.$slots.footer && _vm.isVisible) ? _c('div', {
    staticClass: "box-footer"
  }, [_vm._t("footer")], 2) : _vm._e(), _vm._v(" "), (this.isLoading) ? _c('div', {
    staticClass: "overlay"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v("Select Image")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-arrow-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d382845!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VABox.vue
// module id = 704
// module chunks = 0